import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, TextField , Select, MenuItem, FormControl, InputLabel, Checkbox, FormControlLabel } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';

import { createNewRecord, closeRecord,updateRecord,patialupdateRecord } from './api';
import jsPDF,  {  AcroFormTextField} from 'jspdf';
import autoTable from 'jspdf-autotable'; 
import './OpenSans-Regular-normal';

const RecordForm = ({ selectedRecord, setIsEditMode, setSelectedRecord, handleClose, setRevKey }) => {
  const { t, i18n } = useTranslation();
  const [alias, setAlias] = useState('');
  const [fmsid, setFmsid] = useState('');
  const [name, setName] = useState('');
  const [ammount, setAmmount] = useState(selectedRecord?.ammount || '0');
  const [unit, setUnit] = useState(1); 

  const [description, setDescription] = useState('');
  const [nonstackable, setNonstackable] = useState(null);

  useEffect(() => {
    if (selectedRecord) {
      setAlias(selectedRecord.alias);
      setFmsid(selectedRecord.fmsid);
      setName(selectedRecord.name);
      setAmmount(selectedRecord.ammount);
      setDescription(selectedRecord.description || '');
      setUnit(selectedRecord.unit);
      setNonstackable(selectedRecord.nonstackable);
    }
  }, [selectedRecord]);

  const handleSave = async () => {
    const recordData = { alias, name, ammount, description, fmsid, unit, nonstackable };
    await createNewRecord(recordData);
    handleClose();
    setRevKey(prevKey => prevKey + 1);
  };

  const updateRecord2 = async () => {
      const updatedData = { alias, name, ammount, description, fmsid, unit, nonstackable };
      await updateRecord(selectedRecord.lot, updatedData);
      handleClose();
      setRevKey(prevKey => prevKey + 1);
  }
  const handleUnitChange = (e) => {
    setUnit(e.target.value);
  };

  const getUnitKey = (unitId) => {
    const keys = {
      1: 'pallet',
      2: 'box',
      3: 'piece',
      4: 'case',
      5: 'vial'
    };
    return keys[unitId] || 'pallet';
  };

  const getAmmountText = (count, unitId) => {
    return t(`units.${getUnitKey(unitId)}`, { count });
  };

  const handleCloseRecord = async () => {
    if (selectedRecord) {
      await closeRecord(selectedRecord.lot);
      handleClose();
      setRevKey(prevKey => prevKey + 1);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const locale = i18n.language === 'cs' ? 'cs-CZ' : 'en-GB';

    const formattedDate = date.toLocaleDateString(locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });

    const formattedTime = date.toLocaleTimeString(locale, {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });

    return `${formattedDate}   ${formattedTime}`;
   };

   const getPartAmmountText = (count, unitId) => {
    const text = getAmmountText(count, unitId);
    if (i18n.language === 'cs') {
      if (count === 1) return `${text} byla vydána`;
      if (count >= 2 && count <= 4) return `${text} byly vydány`;
      return `${text} bylo vydáno`;
    }
    return `${text} issued`;
  };


//vydejka
const generatePull = () => {
  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'a4',
  });
  
    const formattedDate = formatDate(new Date());
    const recordLot = selectedRecord?.lot || '-';

    doc.setFont('OpenSans-Regular', 'normal');
    doc.setProperties({
    title: `${t('record_form.pull')} ${recordLot}`,
    author: 'WDS'
});

    doc.setFontSize(50);
    doc.text(`${t('record_form.pull')} ${recordLot}`,110,20, {align: 'center'});
    doc.setFontSize(35);

    doc.text(15, 50, `${t('pdf.date')}: ${formattedDate}`);
    
    autoTable(doc, {
      styles: {fontSize: 12, font: 'OpenSans-Regular'},
      startY: 60,
      head: [[t('pdf.lot'), t('pdf.alias'), t('pdf.name'), t('pdf.amount'), t('pdf.description')]],
      body: [[recordLot, alias, name, ammount, t('pdf.shipment_info')]],
      theme: 'grid',
    });

    doc.text(15,140, `${t('record_form.amount')} ${getAmmountText(5,unit)}: ${ammount}`);

    autoTable(doc, {
     styles: {fontSize: 20},
     startY: 180,
     startX: 20,
     head: [['', '']],
      body: [
          [t('pdf.plate_number'), ''],
          [t('pdf.name'), ''],
          [t('pdf.signature'), ''],
      ],
      columnStyles: { 0: { cellWidth: 50, halign: 'center', cellHigh: '30' } },
      theme: 'grid',
    });

  const lastY = doc.lastAutoTable.finalY;
  const height = 10;

const fieldSPZ = new AcroFormTextField();
fieldSPZ.fieldName = "SPZ";
fieldSPZ.x = 70;
fieldSPZ.width = 120;
fieldSPZ.y = lastY - 34;
fieldSPZ.height = height;

  const fieldName = new AcroFormTextField();
  fieldName.fieldName = "Name";
  fieldName.x = 70;
  fieldName.width = 120;
  fieldName.y = lastY - 22;
  fieldName.height = height;
  
  doc.addField(fieldSPZ);
  doc.addField(fieldName);

  doc.save(`${t('record_form.pull')}_${recordLot}.pdf`)
  };

  //castecna vydejka
  const generatePartialPull = (quantity) => {
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
    });
    
      const formattedDate = formatDate(new Date());
      const currentQuantity = quantity;
      const recordLot = selectedRecord?.lot || '-';
  
      doc.setFont('OpenSans-Regular', 'normal');
      doc.setProperties({
      title: `${t('record_form.partial_pull')} ${recordLot}`,
      author: 'WDS'
  });
  
      doc.setFontSize(40);
      doc.text(`${t('record_form.partial_pull')} ${recordLot}`,110,20, {align: 'center'});
      doc.setFontSize(35);
  
      doc.text(15, 50, `${t('pdf.date')}: ${formattedDate}`);
      
      autoTable(doc, {
        styles: {fontSize: 12, font: 'OpenSans-Regular'},
        headStyles: {
          fillColor: [255, 0, 0],
          textColor: [255, 255, 255],
          fontStyle: 'bold',
        },
        startY: 60,
        head: [[t('pdf.lot'), t('pdf.alias'), t('pdf.name'), t('pdf.amount'), t('pdf.description')]],
        body: [[recordLot, alias, name, currentQuantity, t('pdf.shipment_info')]],
        theme: 'grid',
      });

      doc.text(15,140, `${t('record_form.amount')} ${getAmmountText(5,unit)} (${t('pdf.to_issue')}): ${currentQuantity}`);
  
      autoTable(doc, {
       styles: {fontSize: 20},
       startY: 180,
       startX: 20,
       headStyles: {
        fillColor: [255, 0, 0],
        textColor: [255, 255, 255],
        fontStyle: 'bold',
      },
       head: [['', '']],
        body: [
            [t('pdf.plate_number'), ''],
            [t('pdf.name'), ''],
            [t('pdf.signature'), ''],
        ],
        columnStyles: { 0: { cellWidth: 50, halign: 'center', cellHigh: '30' } },
        theme: 'grid',
      });

    const lastY = doc.lastAutoTable.finalY;
    const height = 10;
  
  const fieldSPZ = new AcroFormTextField();
  fieldSPZ.fieldName = "SPZ";
  fieldSPZ.x = 70;
  fieldSPZ.width = 120;
  fieldSPZ.y = lastY - 34;
  fieldSPZ.height = height;
  
    const fieldName = new AcroFormTextField();
    fieldName.fieldName = "Name";
    fieldName.x = 70;
    fieldName.width = 120;
    fieldName.y = lastY - 22;
    fieldName.height = height;
    
    doc.addField(fieldSPZ);
    doc.addField(fieldName);
  
    doc.save(`${t('record_form.partial_pull')}_${recordLot}.pdf`)
    };



//prijemka
  const generateReceipt = () => {
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4',
    });

    const alias = selectedRecord?.alias || '';
    const name = selectedRecord?.name || '';
    const currentAmmount = selectedRecord?.ammount || '0';
    const recordLot = selectedRecord?.lot || '-';
    const formattedDate = formatDate(new Date());
    doc.setFont('OpenSans-Regular', 'normal');
    doc.setProperties({
    title: `${t('record_form.receipt')} ${recordLot}`,
    author: 'WDS'
});

for (let i = 1; i <= currentAmmount; i++) {
    doc.setFontSize(100);
    doc.text(`${t('record_form.receipt')}`,148.5,30, {align: 'center'});
    doc.setFontSize(40);

    doc.text(`${formattedDate}`,148.5, 55, {align: 'center'});
    doc.text(`${t('pdf.name')}: ${name}`,148.5, 70, {align: 'center'});          
    doc.text(`${t('pdf.alias')}: ${alias}`,148.5, 90, {align: 'center'});           

    doc.setFontSize(100);
    doc.text(`Lot: ${recordLot}`, 148.5, 125, {align: 'center'});

    if (nonstackable === true) {
      doc.setTextColor(255, 0, 0);
      doc.setFontSize(100);
      doc.text(t('record_form.nonstackable'), 148.5, 160, { align: 'center' });
      doc.setTextColor(0, 0, 0);
    }

    doc.text(`${i}. ${getAmmountText(1,unit)} ${t('pdf.of')} ${currentAmmount}`, 148.5, 195, { align: 'center' });

    if (i < currentAmmount) {
      doc.addPage();
    }
  }
   doc.save(`${t('record_form.receipt')}_${recordLot}.pdf`)
  };

//částečný výdej
const handlePartialPull = async () => {
  const input = prompt(t('record_form.partial_pull_prompt'));
  const quantity = parseInt(input, 10);

  if (!isNaN(quantity) && quantity > 0 && quantity <= ammount) {
    const newAmmount = ammount - quantity;
    setAmmount(newAmmount);

    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString(i18n.language === 'cs' ? "cs-CZ" : "en-GB");
    const newDescription = `${description ? description + ' ' : ''}${quantity} ${getPartAmmountText(quantity,unit)} ${t('pdf.on_date')} ${formattedDate}`;

    const updatedData = { alias, name, newAmmount, newDescription, fmsid, unit, nonstackable};
    await patialupdateRecord(selectedRecord.lot, updatedData);
    handleClose();
    setRevKey(prevKey => prevKey + 1);

    await generatePartialPull(quantity);
  } else {
    alert(t('record_form.invalid_amount'));
  }
};

  return (
    <div>        
      <form onSubmit={(e)=>e.preventDefault()}>

      <h2>{selectedRecord ? t('record_form.title_edit') : t('record_form.title_new')}</h2>
      {selectedRecord && (
        <TextField 
          label={t('record_form.lot_id')}
          value={selectedRecord.lot}
          fullWidth
          InputProps={{
            readOnly: true,
          }}
        />
      )}
      <TextField
        label={t('record_form.fms_id')}
        name="FMSID"
        value={fmsid}
        onChange={(e) => setFmsid(e.target.value)}
        fullWidth
        margin="normal"
      />
      <TextField 
        label={t('record_form.alias')}
        name="alias"
        value={alias}
        onChange={(e) => setAlias(e.target.value)}
        fullWidth
        margin="normal"
      />
      <TextField 
        label={t('record_form.name')}
        name="jmeno"
        value={name}
        onChange={(e) => setName(e.target.value)}
        fullWidth
        margin="normal"
      />

      <TextField 
        label={t('record_form.amount')}
        name="mnozstvi"
        value={ammount}
        onChange={(e) => {
          const value = e.target.value;
          if (value === '' || (Number(value) > 0 && /^\d+$/.test(value))) {
            setAmmount(value);
          }
        }}        
        fullWidth
        margin="normal"
        type='number'
      />     
       
      <FormControl fullWidth margin="normal">
          <InputLabel>{t('record_form.unit')}</InputLabel>
          <Select
            label={t('record_form.unit')}
            value={unit}
            onChange={handleUnitChange}
          >
            <MenuItem value={1}>{t('units.pallet_one')}</MenuItem>
            <MenuItem value={2}>{t('units.box_one')}</MenuItem>
            <MenuItem value={3}>{t('units.piece_one')}</MenuItem>
            <MenuItem value={4}>{t('units.case_one')}</MenuItem>
            <MenuItem value={5}>{t('units.vial_one')}</MenuItem>
          </Select>
        </FormControl>
      <TextField 
        name="popis"
        label={t('record_form.description')}
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        fullWidth
        margin="normal"
      />
    <FormControlLabel
          control={
            <Checkbox
              checked={nonstackable === true}
              onChange={(e) =>
                setNonstackable(e.target.checked ? true : null)
              }
            />
          }
          label={t('record_form.nonstackable')}
        />
      <div><Button 
          variant="contained" 
          color="primary"
          onClick={() => generateReceipt()} 
          style={{ marginLeft: '10px' }}>
          {t('record_form.receipt')}
        </Button>
        <Button 
          variant="contained" 
          color="secondary" 
          onClick={() => generatePull()} 
          style={{ marginLeft: '10px' }}>
          {t('record_form.pull')}
        </Button>
        {selectedRecord && (
          <Button variant="contained"
          color="error"
          onClick={handlePartialPull}
          style={{ marginLeft: '10px' }}>
          {t('record_form.partial_pull')}
          </Button>
        )}
        </div>
      <div style={{ marginTop: '20px' }}>
        <Button 
        variant="outlined" 
        color="primary" 
        onClick={selectedRecord ? updateRecord2 : handleSave}
        type='submit'
        endIcon={<SaveIcon/>}
        >
        {selectedRecord ? t('common.edit') : t('common.save')}
  </Button>
        {selectedRecord && (
          <Button variant="outlined" color="secondary" onClick={handleCloseRecord}  endIcon={<DeleteIcon/>} style={{ marginLeft: '10px' }}>{t('common.delete')}</Button>
        )}
        <Button variant="outlined" color="error" onClick={handleClose} endIcon={<CancelIcon/>} style={{ marginLeft: '10px' }}>{t('common.cancel')}</Button>
       
      </div>
      </form>
    </div>
  );
};

export default RecordForm;
